import React from 'react';
import { useDispatch } from 'react-redux';
import { selectSetting } from '../../../../util/store/selectors';
import { useSelector } from "../../../../util/store/store";
import { ISite } from "../../../../util/varibles/interface";
import { PlanSetting } from '../../../../util/varibles/userSetting';
import { updateUserSetting } from "../../../LoginPage/reducer";
import SiteFilter from "../_components/SiteFilter";

export interface IProps {
    sites: ISite[]
}

const Filter: React.FC<IProps> = (props) => {
    const { [PlanSetting.BIOLOGY_SITE]: siteFilter, [PlanSetting.BIOLOGY_PROD_AREA]: prodAreaFilter } = useSelector(selectSetting([PlanSetting.BIOLOGY_SITE, PlanSetting.BIOLOGY_PROD_AREA]))
    const dispatch = useDispatch();

    const updateSetting = ({ siteFilter, prodAreaFilter }: { siteFilter: string[], prodAreaFilter: string[] }) => {
        dispatch(updateUserSetting([{ [PlanSetting.BIOLOGY_SITE]: siteFilter, [PlanSetting.BIOLOGY_PROD_AREA]: prodAreaFilter }]))
    }

    return <SiteFilter
        siteFilter={siteFilter || []}
        prodAreaFilter={prodAreaFilter || []}
        sites={props.sites}
        updateSetting={updateSetting}
    />
};

export default Filter;
